import React from 'react';
import ConditionIndex from '@/components/condition-index';

import './index.less';

export const optionPubEarly = {
  label: '最新发布',
  options: { valueDown2Top: 1, valueTop2Down: 2, valueInit: undefined },
  getlog() {},
};

export const optionActivityStart = {
  label: '活动开始时间',
  options: { valueDown2Top: 3, valueTop2Down: 4, valueInit: undefined },
  getlog() {},
};

const _options = [optionPubEarly, optionActivityStart];

export default function SelectSort({ value, onChange, options = _options }) {
  return (
    <div className="header-condition-other activity-select-sort">
      {options.map((item, key) => (
        <div key={key} className="header-condition-fresh">
          <ConditionIndex options={item.options} getlog={item.getlog} value={value} onChange={onChange}>
            {item.label}
          </ConditionIndex>
        </div>
      ))}
    </div>
  );
}
